import api from './api';

const categorieService = {
  // Récupérer toutes les catégories actives
  getCategories: async () => {
    try {
      const response = await api.get('/categories/actif');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des catégories:', error);
      throw error;
    }
  },

  // Récupérer toutes les catégories (actives et inactives)
  getAllCategories: async () => {
    try {
      const response = await api.get('/categories/all');
      // console.log('Categories API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de toutes les catégories:', error);
      throw error;
    }
  },

  // Récupérer une catégorie par son code
  getCategoryByCode: async (code) => {
    try {
      const response = await api.get(`/categories/${code}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la catégorie:', error);
      throw error;
    }
  },

  // Récupérer les produits d'une catégorie avec pagination
  getCategoryProducts: async (code, params = {}) => {
    try {
      const { page = 1, limit = 12, sort = 'newest' } = params;
      const response = await api.get(`/categories/${code}/products`, {
        params: { page, limit, sort }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits de la catégorie:', error);
      throw error;
    }
  },

  // Créer une nouvelle catégorie
  createCategory: async (categoryData) => {
    try {
      const response = await api.post('/categories', categoryData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la catégorie:', error);
      throw error;
    }
  },

  // Modifier une catégorie
  updateCategory: async (id, categoryData) => {
    try {
      const response = await api.put(`/categories/${id}`, categoryData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la modification de la catégorie:', error);
      throw error;
    }
  },

  // Supprimer une catégorie
  deleteCategory: async (id) => {
    try {
      const response = await api.delete(`/categories/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de la catégorie:', error);
      throw error;
    }
  },

  // Activer/Désactiver une catégorie
  toggleCategoryStatus: async (id) => {
    try {
      const response = await api.patch(`/categories/${id}/toggle`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la modification du statut de la catégorie:', error);
      throw error;
    }
  }
};

export default categorieService;
